import { LAYOUT_OPTIONS } from '@configs'
import { InputWrapperGridStyled } from '@theme'
import { Controller } from 'react-hook-form'
import { Button, Input } from 'src/common'
import { CustomDragger } from 'src/common/upload/CustomDragger'
import { EMediaCategory, EMediaType } from 'src/interfaces/gallery'
import SelectMedia from '../../gallery/SelectMedia'
import { ShareSelectInput } from '../../shared'
import { useBannerTop } from './useBannerTop'
import SelectMediaModal from 'src/components/gallery/SelectMediaModal'
import { Skeleton } from 'antd'
import { Fragment } from 'react'
import { t } from 'i18next'

interface IAboutUsPageTabItemProps {
  activeTab?: string
}
export const BannerTop = ({ activeTab }: IAboutUsPageTabItemProps) => {
  const {
    control,
    setIsChange,
    onChangeDesktopRef,
    setImageSrc,
    setValue,
    setSelectedField,
    setShowModalSelectMedia,
    imageSrc,
    getValues,
    setIsModalLoading,
    isDisabledSaveButton,
    isModalLoading,
    onChangeMobileRef,
    imageMobileSrc,
    onSubmit,
    onSave,
    isChange,
    showModalSelectMedia,
    onCloseModalSelectMedia,
    onSelectMedia,
    getBannerTopActionLoading,
  } = useBannerTop({
    activeTab,
  })
  return (
    <>
      {getBannerTopActionLoading ? (
        <>
          <Skeleton
            paragraph={{ rows: 4 }}
            style={{
              marginTop: 10,
            }}
          />
        </>
      ) : (
        <Fragment>
          <InputWrapperGridStyled>
            <Controller
              name="title"
              control={control}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => {
                return (
                  <Input
                    alignment="col"
                    label="Title"
                    required
                    placeholder={t('evolveLanding:enter_title')}
                    size="middle"
                    value={value}
                    onChange={(e) => {
                      onChange(e?.target?.value)
                      setIsChange(true)
                    }}
                    errors={error?.message}
                  />
                )
              }}
            />

            <Controller
              name="titleInDutch"
              control={control}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => {
                return (
                  <Input
                    alignment="col"
                    label="Title in Netherlands"
                    required
                    size="middle"
                    placeholder={t('evolveLanding:enter_title_in_NL')}
                    value={value}
                    onChange={(e) => {
                      onChange(e?.target?.value)
                      setIsChange(true)
                    }}
                    errors={error?.message}
                  />
                )
              }}
            />
            <Controller
              name="subTitle"
              control={control}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => {
                return (
                  <Input
                    alignment="col"
                    label="Sub-Title"
                    required
                    size="middle"
                    placeholder={t('evolveLanding:enter_subTitle')}
                    value={value}
                    onChange={(e) => {
                      onChange(e?.target?.value)
                      setIsChange(true)
                    }}
                    errors={error?.message}
                  />
                )
              }}
            />

            <Controller
              name="subTitleInDutch"
              control={control}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => {
                return (
                  <Input
                    alignment="col"
                    label="Sub-Title in Netherlands"
                    required
                    size="middle"
                    placeholder={t('evolveLanding:enter_subTitle_in_NL')}
                    value={value}
                    onChange={(e) => {
                      onChange(e?.target?.value)
                      setIsChange(true)
                    }}
                    errors={error?.message}
                  />
                )
              }}
            />
            <Controller
              name="layout"
              control={control}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => {
                return (
                  <ShareSelectInput
                    containerClassName="flex flex-col gap-[10px] !min-w-0 w-[30%]"
                    inlineLabelClassName="!text-start !block !m-0"
                    data={LAYOUT_OPTIONS}
                    onChange={(value: string) => {
                      setIsChange(true)
                      onChange(value)
                    }}
                    label={'Layout'}
                    errors={error?.message}
                    value={value}
                    showArrow
                  />
                )
              }}
            />

            <Controller
              name="textColor"
              control={control}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => {
                return (
                  <Input
                    label="Text color"
                    alignment="col"
                    name="textColor"
                    type="color"
                    required
                    onChange={(e) => {
                      onChange(e?.target?.value)
                      setIsChange(true)
                    }}
                    value={value}
                    errors={error?.message}
                    isDisableShadow
                  />
                )
              }}
            />
            <div className="flex flex-col gap-1 items-end">
              <Controller
                name="mediaId"
                control={control}
                render={({ field: { onChange }, fieldState: { error } }) => {
                  onChangeDesktopRef.current = onChange
                  return (
                    <CustomDragger
                      label="Image"
                      name="mediaTopId"
                      id="mediaTopId"
                      containerClassName="mt-3"
                      alignment="col"
                      required
                      onLoadEnd={(data) => {
                        setValue('mediaId', data?.id ?? 0)
                        onChange(data?.id ?? 0)
                        setIsChange(true)
                        setImageSrc((prev) => data.original ?? prev)
                      }}
                      errors={error?.message}
                      initResource={imageSrc}
                      reset={getValues('mediaId') === 0}
                      limitFileSize={5}
                      allowFileTypes={['image/png', 'image/jpeg', 'image/jpg']}
                      changeLoading={setIsModalLoading}
                      uploadType={EMediaType.IMAGE as any}
                      uploadCategory={EMediaCategory.CONTENT}
                    />
                  )
                }}
              />
              <SelectMedia
                buttonClassName="w-fit ml-auto"
                isNotGrid
                onClickSelectMedia={() => {
                  setSelectedField((pre) => 'desktop')
                  setShowModalSelectMedia(true)
                }}
                isLoadingMedia={isModalLoading}
              />
            </div>

            <div className="flex flex-col gap-1 items-end mb-4">
              <Controller
                name={'mediaMobileId'}
                control={control}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => {
                  onChangeMobileRef.current = onChange
                  return (
                    <>
                      <CustomDragger
                        label="Image mobile"
                        containerClassName="mt-[10px]"
                        alignment="col"
                        onLoadEnd={(data) => {
                          setValue('mediaMobileId', data?.id ?? 0)
                          onChange(data?.id ?? 0)
                          setIsChange(true)
                        }}
                        name="mediaMobileTopId"
                        id="mediaMobileTopId"
                        required
                        errors={error?.message}
                        multiple={false}
                        initResource={imageMobileSrc}
                        reset={getValues('mediaMobileId') === 0}
                        allowFileTypes={[
                          'image/png',
                          'image/jpeg',
                          'image/jpg',
                        ]}
                        limitFileSize={5}
                        changeLoading={setIsModalLoading}
                        uploadType={EMediaType.IMAGE as any}
                        uploadCategory={EMediaCategory.CONTENT}
                      />
                    </>
                  )
                }}
              />
              <SelectMedia
                buttonClassName="w-fit ml-auto"
                isNotGrid
                onClickSelectMedia={() => {
                  setSelectedField((pre) => 'mobile')
                  setShowModalSelectMedia(true)
                }}
                isLoadingMedia={isModalLoading}
              />
            </div>
          </InputWrapperGridStyled>
          <div className="landing-image-wrapper mt-6">
            <div className="landing-image-action mt-5">
              <div className="landing-save-cancel flex items-center justify-end">
                <Button className="mr-5" type="primary" onClick={onSubmit}>
                  Preview
                </Button>
                {/* <Button
                      className="mr-5"
                      onClick={onCancel}
                      disabled={isModalLoading || !isChange}
                    >
                      Reset
                    </Button> */}
                <Button
                  type="primary"
                  onClick={onSave}
                  loading={isDisabledSaveButton || isModalLoading}
                  disabled={isDisabledSaveButton || isModalLoading || !isChange}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
          {showModalSelectMedia ? (
            <>
              <SelectMediaModal
                isOpen={showModalSelectMedia}
                onClose={onCloseModalSelectMedia}
                mediaType={EMediaType.IMAGE}
                category={EMediaCategory.CONTENT}
                onSelectMedia={onSelectMedia}
              />
            </>
          ) : (
            <></>
          )}
        </Fragment>
      )}
    </>
  )
}
